export default __webpack_public_path__ + "static/media/fb-ico.70c55797.svg";